import React, { useEffect, useRef, useState } from "react";

import {
  useRevalidateAndCalculations,
  validate,
} from "@/components/add-v2/validate";
import { dispatchCtxChange } from "@/components/add-v2/ui";
import css from "./.module.scss";
import { Slider } from "@aqar-app/react-ui";

const NumberFormat = new Intl.NumberFormat("en-SA", {
  maximumFractionDigits: 2,
});

function format(value) {
  if (value === null) return "";
  if (value === undefined) return "";
  if (value === "") return "";
  if ((value + "").endsWith("."))
    return NumberFormat.format(value.slice(0, value.length - 1)) + ".";

  return NumberFormat.format(value);
}

export function SliderFieldComponent({
  rules,
  label,
  dependencies,
  name,
  hide,
  ctxRef,
  nested,
  type,
  note,
  value: initialValue,
  defaultValue,
  dynamicProps: dp,
  calculations,
  range,
  ...props
} = {}) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(null);
  const rootRef = useRef(null);
  const dynamicProps = useRevalidateAndCalculations({
    rules,
    name,
    label: label?.ar,
    calculations,
    value,
    setError,
    setValue,
    dependencies,
    ctxRef,
    dynamicProps: dp,
  });

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.addEventListener("validate", (e) => {
      setError(e?.detail?.error);
    });
  }, []);

  return (
    <div ref={rootRef}>
      <p>{label?.ar || name}</p>
      <div
        className={
          css.slider +
          (props.readOnly ? " " + css.readOnly : "") +
          (error ? " " + css.hasError : "")
        }
      >
        <p> {range?.min}</p>
        <div className={css.sliderRange}>
          <Slider
            {...props}
            {...dynamicProps}
            value={value}
            name={name}
            min={range.min}
            max={range.max}
            step={range.step}
            onChange={(e) => {
              const currentValue = e.target.value;

              setValue(currentValue);
              setError(
                validate({
                  rules,
                  label: label?.ar,
                  currentValue,
                  ctx: ctxRef.current,
                }),
              );
              dispatchCtxChange(e.target, {
                value: +currentValue,
                name,
                nested,
              });
            }}
          />
        </div>

        <p> {value || 0}</p>
      </div>
      <p className={css.error}> {error}</p>
    </div>
  );
}
